<div class="flex flex-col  items-center justify-center gap-[2rem] sm:h-[21.1rem] min-h-[21.1rem] sm:w-[23.5rem] min-w-[23.5rem] text-center  overflow-hidden">
    <div class="">
        <dsr-icon name="{{icon_name}}" class="sm:!size-[6.4rem] !size-[8.4rem]" color="black"/>
    </div>
    <div class="min-h-[5.8rem] flex flex-col">
        <span class="dsr-typescale-body-small-prominent sm:hidden">{{title}} </span>
        <span class="dsr-typescale-body-medium-prominent max-sm:hidden">{{title}} </span>
        <span class="dsr-typescale-body-small-prominent sm:hidden">{{subtitle}} </span>
        <span class="dsr-typescale-body-medium-prominent max-sm:hidden">{{subtitle}} </span>
    </div>
</div>